import { useSelector } from "react-redux";
import { selectUnit } from "../../../../../ducks/data/finance/units/selectors";
import { selectIsFinanceIntegrationPowerOffice } from "../../../../../ducks/data/finance/selectors";
import { useTranslation } from "react-i18next";

const UnitCellValue = (props: { unitId: string }) => {
  const unit = useSelector(selectUnit(props.unitId));
  const { t } = useTranslation("types");
  const isPowerOffice = useSelector(selectIsFinanceIntegrationPowerOffice);
  return unit ? (
    <>
      {isPowerOffice
        ? t(`powerOfficeProductUnits.${unit.name}` as any)
        : unit.name}
    </>
  ) : null;
};

export default UnitCellValue;
